module.exports = __webpack_public_path__ + "img/base_hiver_stade_alpin.f947170a.svg";